export const appVersion = "1.4.4";
